import type {ReactElement} from 'react';
import {useRef} from 'react';
import {useState} from 'react';
import React from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import styles from './nav-file-language-option.module.scss';
import {LanguageSelector} from '@Components/language-selector';
import {ControlledListItemType7} from '@Components/controlled-list/components/controlled-list-item-type-7';

export function NavFileLanguageOption(): ReactElement<any> {
  const [isHovered, setIsHovered] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const onClickLanguageDropdown = (e: React.MouseEvent<HTMLElement>): void => {
    e.stopPropagation();
    e.preventDefault();
  };

  const onMouseEnter = (): void => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    setTimeout((): void => {
      setIsHovered(true);
    }, 300);
  };

  const onMouseExit = (): void => {
    timeoutRef.current = setTimeout((): void => {
      setIsHovered(false);
    }, 300);
  };

  const getLanguageDropdownSelector = (): ReactElement<any> => {
    return (
      <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseExit}>
        <ControlledListItemType7
          rightIconClassName={styles.rightIconColor}
          rightIcon="icon-caret-right"
          className="spacing-m-b-2"
          id="language-dropdown"
          text={window.i18next.t('pmwjs_language')}
          icon="icon-translation"
        />
      </div>
    );
  };

  return (
    <div onClick={onClickLanguageDropdown}>
      <Dropdown
        open={isHovered}
        leftOffset={8}
        position={DROPDOWN_POSITION.FIXED}
        alignment={ALIGNMENT_TYPE.RIGHT_START}
        selector={getLanguageDropdownSelector()}
        popupClassName={`${styles.languagePopup} flex-center`}
        popup={
          <div className="_full-width _full-height" onMouseEnter={onMouseEnter} onMouseLeave={onMouseExit}>
            <LanguageSelector showListOnly />
          </div>
        }
      />
    </div>
  );
}
